import React, { createContext, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { initialContext} from "./context/context";
import './jsi.css';
import App from './App';

const path = (/#!(\/.*)$/.exec(window.location.href) || [])[1]

export const VTContext = createContext();

export const VTContextProvider = props => {
    const initialContextState = sessionStorage.getItem('VTContext') ? JSON.parse(sessionStorage.getItem('VTContext')) : initialContext;
    const [state, setState] = useState(initialContextState);
    return (
        <VTContext.Provider value={[state, setState]}>
            {props.children}
        </VTContext.Provider>
    );
};

const root = createRoot(document.getElementById('root'));

root.render(
    <VTContextProvider>
        <App />
    </VTContextProvider>
);
